import { useProfile } from "@/hooks/useProfile";

export const usePermissions = () => {
  const { profile } = useProfile();

  const checkPermission = (
    codice: string,
    tipo: "inserimento" | "modifica" | "cancellazione"
  ) => {
    // Se è admin, ha tutti i permessi
    if (profile?.role.nome === "ADMIN") return true;

    // Se è collaboratore, verifica i permessi specifici
    if (profile?.role.nome === "COLLABORATORE") {
      const permesso = profile.data.permessi.find(
        (p) => p.permessoCodice === codice
      );

      console.log(permesso);
      return permesso ? permesso[tipo] : false;
    }

    return false;
  };

  return {
    canInsert: (codice: string) => checkPermission(codice, "inserimento"),
    canEdit: (codice: string) => checkPermission(codice, "modifica"),
    canDelete: (codice: string) => checkPermission(codice, "cancellazione"),
  };
};
